import { jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { HXSimpleDialog } from "./HXSimpleDialog";
import { SimpleDialogModel } from "./SimpleDialogModel";
export class ConfirmUserDeleteDialogModel extends SimpleDialogModel {
    constructor() {
        super(...arguments);
        this.user = null;
    }
}
export const ConfirmUserDeleteDialog = observer((props) => {
    return (_jsxs(HXSimpleDialog, { open: props.open, onClose: props.onClose, buttons: [
            [true, "Yes, remove", { destructiveAction: true }],
            [false, "Not now"],
        ], closeChoice: false, title: `Are you sure you want to delete ${props.name}?`, children: ["Removing this user will revoke their access to ", props.orgName, " on HealthEx and prevent them from logging in. Any associated data or permissions assigned to them will also be deleted. This action cannot be undone."] }));
});
